import Cookies from 'js-cookie'

const TokenKey = 'crm_login_key'
const TokenExpiresAtKey = 'crm_login_expires_at'
const DingPasswordRequiredKey = 'ding_password_required'
const UserSessionStorageKeys = [
  'loginUserInfo',
  'clickCustomerInfo',
  'clickCaseInfo',
  'clickContractInfo',
  'clickLetterForm',
  'editLetterForm',
  'visitCustomer',
  'editVisitRow',
  'contract_receivables_list',
  'customerTabNum',
  'caseTabNum',
  'contractTabNum'
]

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token, expiresIn) {
  const expiresInSeconds = Number(expiresIn)
  if (!Number.isFinite(expiresInSeconds) || expiresInSeconds <= 0) {
    throw new Error('登录凭证有效期无效')
  }

  const expiresAt = Date.now() + expiresInSeconds * 1000
  const cookieOptions = {
    expires: new Date(expiresAt),
    path: '/'
  }

  Cookies.set(TokenExpiresAtKey, String(expiresAt), cookieOptions)
  return Cookies.set(TokenKey, token, cookieOptions)
}

export function removeToken() {
  Cookies.remove(TokenExpiresAtKey, { path: '/' })
  return Cookies.remove(TokenKey, { path: '/' })
}

export function setDingPasswordRequired() {
  localStorage.setItem(DingPasswordRequiredKey, '1')
}

export function clearDingPasswordRequired() {
  localStorage.removeItem(DingPasswordRequiredKey)
}

export function isDingPasswordRequired() {
  return localStorage.getItem(DingPasswordRequiredKey) === '1'
}

export function clearUserSessionStorage(preserveRedirect = false) {
  // 只清理 CRM 会话数据，避免误删钉钉密码重登标记及其他持久配置。
  UserSessionStorageKeys.forEach(key => localStorage.removeItem(key))
  if (!preserveRedirect) {
    localStorage.removeItem('redirectUrl')
  }
}
